function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncWorkhours({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    id: "ecology",
    fill: "grey",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.751 0 0 10.751 0 24s10.751 24 24 24 24-10.751 24-24S37.249 0 24 0zm0 1c12.708 0 23 10.292 23 23 0 12.709-10.292 23-23 23S1 36.709 1 24C1 11.292 11.292 1 24 1zm-.05 9.15c-.57.01-1.01.114-1.487.356-.656.332-1.167.861-1.553 1.578.006-.011-.189.334-.474.828l-1.157 1.996c-.517.893-1.234 2.124-1.883 3.24h1.155a5410.446 5410.446 0 0 0 2.75-4.742c.286-.494.436-.753.49-.853.315-.584.651-.921 1.123-1.16.387-.196.57-.24 1.053-.248v.01h.002c.484-.01.753.05 1.136.245.44.224.831.624 1.143 1.213.033.062.067.117.148.258l.338.586 1.162 2.004.729 1.252-2.576-.69-.258.965 4.346 1.164 1.166-4.345-.967-.26-.756 2.822-.818-1.406c-.476-.82-.877-1.507-1.162-2l-.336-.584-.131-.229c-.388-.733-.92-1.302-1.574-1.634a3.27 3.27 0 0 0-1.608-.356h-.002v-.01zm-9.606 13.998-4.348 1.166.26.965 2.861-.767-.728 1.256a2082.287 2082.287 0 0 1-1.672 2.865c-.52.843-.732 1.47-.715 2.21.02.92.37 1.704 1.043 2.36.312.305.53.463.84.606.217.1.462.194.666.246.27.068.585.075 1.793.086.807.01 2.854.01 4.658.01v-1.005c-1.802 0-3.85.002-4.65-.01-1.197-.01-1.523-.047-1.557-.056h-.002a4.687 4.687 0 0 1-.488-.185c-.252-.117-.275-.134-.563-.415-.532-.518-.724-.954-.74-1.664-.013-.571.09-.892.566-1.666a1882.563 1882.563 0 0 0 2.293-3.932l.68 2.536.967-.258-1.164-4.348zm19.191 1a9971.856 9971.856 0 0 0 2.49 4.27c.293.5.448.767.508.863.407.651.461.818.469 1.461.006.48.012.449-.07.707-.11.347-.266.617-.534.914-.345.384-.646.565-1.136.69-.264.067-.338.069-1.494.082-.696.01-2.535.014-4.067.011h-1.763l1.953-1.953-.707-.707-3.182 3.182 3.182 3.182.707-.707-1.993-1.993H30.195c1.393 0 2.953 0 3.584-.01 1.161-.012 1.405-.03 1.73-.113a3.194 3.194 0 0 0 1.632-.988c.347-.385.593-.806.744-1.281.095-.301.123-.527.117-1.022-.009-.743-.175-1.264-.621-1.978.003.01-.2-.339-.492-.838l-1.178-2.018-1.022-1.754h-1.154z",
    color: "#b5b5b5",
    fontFamily: "sans-serif",
    fontWeight: 500,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#b5b5b5",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncWorkhours);
export default __webpack_public_path__ + "static/media/sync-workhours.87e87f2b13e0ffcdcb96af7495fed7fb.svg";
export { ForwardRef as ReactComponent };